import { RestFilters, defaultFilters } from "@instead/shared";
import { drafts, FILTERS_KEY } from "./drafts.ts";

/** The Home question's state — remembered on the device, never reset by itself (round 4). */
export function loadFilters(): RestFilters {
  const raw = drafts.read<unknown>(FILTERS_KEY);
  const parsed = RestFilters.safeParse(raw ?? {});
  if (parsed.success && raw) return parsed.data;
  return { ...defaultFilters(), timeMin: 5 }; // the wheel opens on 5 min
}

export function saveFilters(f: RestFilters): void {
  drafts.write(FILTERS_KEY, f);
}

/** Wheel steps: 1-min to 15, then 5-min to 60, then 15-min to 3 h. */
export const TIME_STEPS: number[] = [
  ...Array.from({ length: 15 }, (_, i) => i + 1),
  ...Array.from({ length: 9 }, (_, i) => 20 + i * 5),
  ...Array.from({ length: 8 }, (_, i) => 75 + i * 15),
];
